export default __webpack_public_path__ + "static/media/item-2.a20561e9.webp";